import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loading-overlay__content" }
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay__text"
}

import { computed, ref, watch, onUnmounted } from 'vue';

interface Props {
  show: boolean;
  text?: string;
  variant?: 'default' | 'save' | 'delete' | 'light';
  fullscreen?: boolean;
  spinnerSize?: number;
  /** 이 시간(ms) 이상 걸릴 때만 오버레이 표시 — 짧은 요청 깜빡임 방지 */
  delayMs?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingOverlay',
  props: {
    show: { type: Boolean },
    text: { default: '' },
    variant: { default: 'default' },
    fullscreen: { type: Boolean, default: false },
    spinnerSize: { default: 40 },
    delayMs: { default: 220 }
  },
  setup(__props: any) {

const props = __props;

const visible = ref(false);
let delayTimer: ReturnType<typeof setTimeout> | null = null;

const clearDelayTimer = () => {
  if (delayTimer) {
    clearTimeout(delayTimer);
    delayTimer = null;
  }
};

watch(
  () => props.show,
  (isShowing) => {
    clearDelayTimer();
    if (isShowing) {
      if (props.delayMs <= 0) {
        visible.value = true;
        return;
      }
      delayTimer = setTimeout(() => {
        if (props.show) {
          visible.value = true;
        }
      }, props.delayMs);
    } else {
      visible.value = false;
    }
  },
  { immediate: true }
);

onUnmounted(clearDelayTimer);

const useTeleport = computed(() => props.fullscreen);
const teleportTarget = computed(() => (props.fullscreen ? 'body' : undefined));

const spinnerColor = computed(() => {
  switch (props.variant) {
    case 'save':
      return '#1565c0';
    case 'delete':
      return '#c62828';
    case 'light':
      return '#64748b';
    default:
      return '#1e3a5f';
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(_Teleport, {
    to: teleportTarget.value,
    disabled: !useTeleport.value
  }, [
    _createVNode(_Transition, { name: "loading-fade" }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["loading-overlay", [
          `loading-overlay--${__props.variant}`,
          { 'loading-overlay--fullscreen': __props.fullscreen }
        ]])
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: spinnerColor.value,
                  size: __props.spinnerSize,
                  width: 3
                }, null, 8, ["color", "size"]),
                (__props.text)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.text), 1))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 8, ["to", "disabled"]))
}
}

})